export default __webpack_public_path__ + "static/media/skin-health-logo.a9a60dfe.svg";